/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPFSPDetails } from './IAPFSPDetails';
import {
    IAPFSPDetailsFromJSON,
    IAPFSPDetailsFromJSONTyped,
    IAPFSPDetailsToJSON,
} from './IAPFSPDetails';

/**
 * 
 * @export
 * @interface IAPIntermediaryDetailsViewModel
 */
export interface IAPIntermediaryDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    intermediaryId?: number;
    /**
     * 
     * @type {number}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    intermediaryClientId?: number;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    preferredName?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    subCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    registrationNo?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    intermediaryStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    distributionChannel?: string;
    /**
     * 
     * @type {number}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    productDistributionId?: number;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    contactNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    alternativeContactNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    emailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    closedForNewBusinessReason?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    dateOfBirth?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    reportsToCode?: string;
    /**
     * 
     * @type {number}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    reportsToId?: number;
    /**
     * 
     * @type {IAPFSPDetails}
     * @memberof IAPIntermediaryDetailsViewModel
     */
    fspDetails: IAPFSPDetails;
}

/**
 * Check if a given object implements the IAPIntermediaryDetailsViewModel interface.
 */
export function instanceOfIAPIntermediaryDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fspDetails" in value;

    return isInstance;
}

export function IAPIntermediaryDetailsViewModelFromJSON(json: any): IAPIntermediaryDetailsViewModel {
    return IAPIntermediaryDetailsViewModelFromJSONTyped(json, false);
}

export function IAPIntermediaryDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPIntermediaryDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'intermediaryId': !exists(json, 'IntermediaryId') ? undefined : json['IntermediaryId'],
        'intermediaryClientId': !exists(json, 'IntermediaryClientId') ? undefined : json['IntermediaryClientId'],
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'firstName': !exists(json, 'FirstName') ? undefined : json['FirstName'],
        'preferredName': !exists(json, 'PreferredName') ? undefined : json['PreferredName'],
        'address': !exists(json, 'Address') ? undefined : json['Address'],
        'category': !exists(json, 'Category') ? undefined : json['Category'],
        'subCategory': !exists(json, 'SubCategory') ? undefined : json['SubCategory'],
        'registrationNo': !exists(json, 'RegistrationNo') ? undefined : json['RegistrationNo'],
        'intermediaryStatus': !exists(json, 'IntermediaryStatus') ? undefined : json['IntermediaryStatus'],
        'distributionChannel': !exists(json, 'DistributionChannel') ? undefined : json['DistributionChannel'],
        'productDistributionId': !exists(json, 'ProductDistributionId') ? undefined : json['ProductDistributionId'],
        'contactNumber': !exists(json, 'ContactNumber') ? undefined : json['ContactNumber'],
        'alternativeContactNumber': !exists(json, 'AlternativeContactNumber') ? undefined : json['AlternativeContactNumber'],
        'emailAddress': !exists(json, 'EmailAddress') ? undefined : json['EmailAddress'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'closedForNewBusinessReason': !exists(json, 'ClosedForNewBusinessReason') ? undefined : json['ClosedForNewBusinessReason'],
        'dateOfBirth': !exists(json, 'DateOfBirth') ? undefined : json['DateOfBirth'],
        'externalId': !exists(json, 'ExternalId') ? undefined : json['ExternalId'],
        'country': !exists(json, 'Country') ? undefined : json['Country'],
        'reportsToCode': !exists(json, 'ReportsToCode') ? undefined : json['ReportsToCode'],
        'reportsToId': !exists(json, 'ReportsToId') ? undefined : json['ReportsToId'],
        'fspDetails': IAPFSPDetailsFromJSON(json['FspDetails']),
    };
}

export function IAPIntermediaryDetailsViewModelToJSON(value?: IAPIntermediaryDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IntermediaryId': value.intermediaryId,
        'IntermediaryClientId': value.intermediaryClientId,
        'Name': value.name,
        'FirstName': value.firstName,
        'PreferredName': value.preferredName,
        'Address': value.address,
        'Category': value.category,
        'SubCategory': value.subCategory,
        'RegistrationNo': value.registrationNo,
        'IntermediaryStatus': value.intermediaryStatus,
        'DistributionChannel': value.distributionChannel,
        'ProductDistributionId': value.productDistributionId,
        'ContactNumber': value.contactNumber,
        'AlternativeContactNumber': value.alternativeContactNumber,
        'EmailAddress': value.emailAddress,
        'Title': value.title,
        'ClosedForNewBusinessReason': value.closedForNewBusinessReason,
        'DateOfBirth': value.dateOfBirth,
        'ExternalId': value.externalId,
        'Country': value.country,
        'ReportsToCode': value.reportsToCode,
        'ReportsToId': value.reportsToId,
        'FspDetails': IAPFSPDetailsToJSON(value.fspDetails),
    };
}

